<ui-select
  [options]="options"
  [value]="selectedStoreId"
  (valueChange)="onValueChange($event)"
  [mode]="'button-group'"
  [direction]="direction"
  [variant]="'warning'"
  [size]="size"
  [fullWidth]="direction === 'horizontal'"
  [ariaLabel]="direction === 'horizontal' ? 'Horizontal store selection' : 'Vertical store selection'"
></ui-select>


